import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../../store/utility';
import { backend_server_address } from '../../../../../backendServer';
import { problemsAPI } from './problemsDuck';
import { findingsAPI } from './findingsDuck';
import { diagnosticsAPI } from './diagnosticsDuck';

export const measurementsV3API = createApi({
    reducerPath: 'measurementsV3API',
    baseQuery: axiosBaseQuery({ baseUrl: backend_server_address + '/api/model/v3/measurements/' }),
    tagTypes: ['GlobalMetadata', 'NodeMetadata'],
    endpoints: (builder) => ({
        getGlobalMetadata: builder.query({
            query: () => ({
                url: 'global_metadata/',
                method: 'GET',
                withCredentials: true,
            }),
            providesTags: () => ['GlobalMetadata'],
        }),
        getNodeMetadata: builder.query({
            query: (id) => ({
                url: `${id}/metadata/`,
                method: 'GET',
                withCredentials: true,
            }),
            providesTags: (result, error, id) => [{ type: 'NodeMetadata', id }],
        }),
        getMeasurements: builder.mutation({
            query: (data) => {
                return {
                    url: 'query/',
                    method: 'POST',
                    withCredentials: true,
                    data,
                };
            },
        }),
    }),
});

export const { endpoints, useGetGlobalMetadataQuery, useGetNodeMetadataQuery, useGetMeasurementsMutation } =
    measurementsV3API;
export const measurementsV3APIReducer = measurementsV3API.reducer;
export const measurementsV3APIReducerPath = measurementsV3API.reducerPath;
export const measurementsV3APIReducerMiddleware = measurementsV3API.middleware;

// Diagnostics-related APIs shared across the analysis and diagnostics modules
export const { useGetProblemTypesQuery, useGetProblemsQuery, useCreateProblemMutation, useEditProblemMutation } =
    problemsAPI;
export const problemsAPIReducer = problemsAPI.reducer;
export const problemsAPIReducerPath = problemsAPI.reducerPath;
export const problemsAPIReducerMiddleware = problemsAPI.middleware;

export const { useGetFindingTypesQuery, useGetFindingsQuery, useCreateFindingMutation } = findingsAPI;
export const findingsAPIReducer = findingsAPI.reducer;
export const findingsAPIReducerPath = findingsAPI.reducerPath;
export const findingsAPIReducerMiddleware = findingsAPI.middleware;

export const {
    useGetDiagnosticsQuery,
    useGetDiagnosticByIdQuery,
    useGetDiagnosticTrackingQuery,
    useGetDiagnosticMetadataQuery,
} = diagnosticsAPI;
export const diagnosticsAPIReducer = diagnosticsAPI.reducer;
export const diagnosticsAPIReducerPath = diagnosticsAPI.reducerPath;
export const diagnosticsAPIReducerMiddleware = diagnosticsAPI.middleware;
